import {Component, inject, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import {Blocks} from 'app/entities/blockElements/block.entity';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import {AppService} from 'app/services/app.service';
import {BlockSkeletonType} from 'app/entities/enums';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-blocks-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlocksModalComponent extends ModalComponent implements OnInit {
  blocksGetMethod: any = null;
  data: any = null;
  skeletonType: BlockSkeletonType = 'default';

  loading = true;

  header: Blocks[] = [];
  content: Blocks[] = [];

  appService = inject(AppService);

  constructor(
    modalController: ModalController
  ) {
    super(modalController);
  }

  ngOnInit() {
    this.blocksGetMethod((response: ApiResponse) => {
      if (response.status) {
        this.header = response.result.header;
        this.content = response.result.content;
        this.loading = false;
      } else {
        if (response.message) {
          this.appService.showToast(response.message, 'danger');
        }

        this.closeModal();
      }
    });
  }
}
